















import { Vue, Component } from "vue-property-decorator";

// Enums/Data
import { TemplateTypes, TemplateCodes } from "@/data/enums/templates";

@Component({
  components: {
    "template-provider": () =>
      import("@/components/app/global/templates/templateProvider.vue"),
    "invoice-template-edit-form": () =>
      import(
        "@/components/app/global/templates/invoices/invoiceTemplateEditForm.vue"
      )
  }
})
export default class InvoiceTemplateView extends Vue {
  public templateType = TemplateTypes.DOCUMENT;
  public templateCode = TemplateCodes.INVOICE_PDF;
}
